import React from 'react';

export default function PictoDeli40() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_840_874)">
        <g clipPath="url(#clip1_840_874)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M38 17C38 21.3542 35.4701 25.1176 31.8 26.9003L23.6911 32.1115C25.898 29.7631 27.25 26.602 27.25 23.125C27.25 15.8763 21.3737 10 14.125 10C12.7603 10 11.4443 10.2083 10.2069 10.5948C10.2369 10.5732 10.2697 10.5545 10.3052 10.5395L22.3052 7.03952C22.3295 7.02925 22.3541 7.02104 22.3789 7.01481C23.7839 6.3635 25.3495 6 27 6C33.0751 6 38 10.9249 38 17Z"
            fill="#DAD8D2"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.3095 26.0268L31.3631 26.0008C34.7019 24.379 37 20.9569 37 17C37 11.4772 32.5228 7 27 7C25.4977 7 24.0754 7.3306 22.7995 7.92207L22.7138 7.96179L22.6596 7.97539L22.6412 7.9832L10.7143 11.4619L10.6603 11.5008L10.5051 11.5493C5.57568 13.0891 2 17.6908 2 23.125C2 29.8215 7.42854 35.25 14.125 35.25C17.6095 35.25 20.7494 33.7815 22.9623 31.4267L23.0467 31.3369L31.3095 26.0268ZM10.3052 10.5395L22.3052 7.03952C22.3295 7.02925 22.3541 7.02104 22.3789 7.01481C23.7839 6.3635 25.3495 6 27 6C33.0751 6 38 10.9249 38 17C38 21.3542 35.4701 25.1176 31.8 26.9003L23.6911 32.1115C21.297 34.659 17.8968 36.25 14.125 36.25C6.87626 36.25 1 30.3737 1 23.125C1 17.241 4.87194 12.2613 10.2069 10.5948C10.2369 10.5732 10.2697 10.5545 10.3052 10.5395Z"
            fill="#142138"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.125 35.25C20.8214 35.25 26.25 29.8215 26.25 23.125C26.25 16.4286 20.8214 11 14.125 11C7.42854 11 2 16.4285 2 23.125C2 29.8215 7.42854 35.25 14.125 35.25ZM27.25 23.125C27.25 30.3737 21.3737 36.25 14.125 36.25C6.87626 36.25 1 30.3737 1 23.125C1 15.8763 6.87626 10 14.125 10C21.3737 10 27.25 15.8763 27.25 23.125Z"
            fill="#142138"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5 22.25C14.0188 22.25 15.25 21.0188 15.25 19.5C15.25 17.9812 14.0188 16.75 12.5 16.75C10.9812 16.75 9.75 17.9812 9.75 19.5C9.75 21.0188 10.9812 22.25 12.5 22.25ZM16.25 19.5C16.25 21.5711 14.5711 23.25 12.5 23.25C10.4289 23.25 8.75 21.5711 8.75 19.5C8.75 17.4289 10.4289 15.75 12.5 15.75C14.5711 15.75 16.25 17.4289 16.25 19.5Z"
            fill="#142138"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 29.75C10.8284 29.75 11.5 29.0784 11.5 28.25C11.5 27.4216 10.8284 26.75 10 26.75C9.17157 26.75 8.5 27.4216 8.5 28.25C8.5 29.0784 9.17157 29.75 10 29.75ZM12.5 28.25C12.5 29.6307 11.3807 30.75 10 30.75C8.61929 30.75 7.5 29.6307 7.5 28.25C7.5 26.8693 8.61929 25.75 10 25.75C11.3807 25.75 12.5 26.8693 12.5 28.25Z"
            fill="#142138"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.5 27.25C18.3284 27.25 19 26.5784 19 25.75C19 24.9216 18.3284 24.25 17.5 24.25C16.6716 24.25 16 24.9216 16 25.75C16 26.5784 16.6716 27.25 17.5 27.25ZM20 25.75C20 27.1307 18.8807 28.25 17.5 28.25C16.1193 28.25 15 27.1307 15 25.75C15 24.3693 16.1193 23.25 17.5 23.25C18.8807 23.25 20 24.3693 20 25.75Z"
            fill="#142138"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36.4389 6.50375C36.6051 6.48329 36.7706 6.54743 36.8796 6.67461L39.8796 10.1746C39.9984 10.3132 40.0322 10.5054 39.9679 10.6762C39.9036 10.847 39.7514 10.9692 39.5707 10.995L36.0707 11.495C35.7973 11.534 35.5441 11.3441 35.505 11.0707C35.466 10.7973 35.6559 10.5441 35.9293 10.505L38.5276 10.1338L36.6104 7.89715L35.4472 10.2236C35.3237 10.4706 35.0234 10.5707 34.7764 10.4472C34.5294 10.3237 34.4293 10.0234 34.5528 9.7764L36.0528 6.7764C36.1277 6.62658 36.2726 6.52422 36.4389 6.50375Z"
            fill="#142138"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_840_874">
          <rect width="40" height="40" fill="white" />
        </clipPath>
        <clipPath id="clip1_840_874">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
